var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "services_page_wrapper" } },
    [
      _c("div", { staticClass: "bb-mobile-header" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("services.title")))]),
        _c("div", { staticClass: "bb-mobile-header-right" }, [
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  return _vm.openMobileServicesFilter()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 22 22",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M18.0642 0H3.93577C1.76559 0 0 1.76559 0 3.93577V18.0643C0 20.2344 1.76559 22 3.93577 22H18.0643C20.2344 22 22 20.2344 22 18.0642V3.93577C22 1.76559 20.2344 0 18.0642 0ZM20.7109 18.0642C20.7109 19.5236 19.5236 20.7109 18.0642 20.7109H3.93577C2.47638 20.7109 1.28906 19.5236 1.28906 18.0642V3.93577C1.28906 2.47638 2.47638 1.28906 3.93577 1.28906H18.0643C19.5236 1.28906 20.7109 2.47638 20.7109 3.93577V18.0642Z",
                      fill: "#253342",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.5942 4.83262H8.77756C8.50767 4.03104 7.74949 3.4519 6.85806 3.4519C5.96663 3.4519 5.20845 4.03104 4.93856 4.83262H3.40625C3.0503 4.83262 2.76172 5.1212 2.76172 5.47715C2.76172 5.8331 3.0503 6.12168 3.40625 6.12168H4.9386C5.20849 6.92326 5.96667 7.5024 6.8581 7.5024C7.74953 7.5024 8.50772 6.92326 8.7776 6.12168H18.5943C18.9502 6.12168 19.2388 5.8331 19.2388 5.47715C19.2388 5.1212 18.9502 4.83262 18.5942 4.83262ZM6.85806 6.21333C6.45213 6.21333 6.12188 5.88308 6.12188 5.47715C6.12188 5.07122 6.45213 4.74097 6.85806 4.74097C7.26399 4.74097 7.59424 5.07122 7.59424 5.47715C7.59424 5.88308 7.26399 6.21333 6.85806 6.21333Z",
                      fill: "#253342",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.5942 10.3556H17.0619C16.792 9.55399 16.0338 8.97485 15.1424 8.97485C14.251 8.97485 13.4928 9.55399 13.2229 10.3556H3.40625C3.0503 10.3556 2.76172 10.6441 2.76172 11.0001C2.76172 11.3561 3.0503 11.6446 3.40625 11.6446H13.2229C13.4928 12.4462 14.251 13.0253 15.1424 13.0253C16.0338 13.0253 16.792 12.4462 17.0619 11.6446H18.5943C18.9502 11.6446 19.2388 11.3561 19.2388 11.0001C19.2388 10.6441 18.9502 10.3556 18.5942 10.3556ZM15.1424 11.7363C14.7365 11.7363 14.4063 11.406 14.4063 11.0001C14.4063 10.5942 14.7365 10.2639 15.1424 10.2639C15.5484 10.2639 15.8786 10.5942 15.8786 11.0001C15.8786 11.406 15.5484 11.7363 15.1424 11.7363Z",
                      fill: "#253342",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.5942 15.8784H11.539C11.2691 15.0768 10.511 14.4977 9.61953 14.4977C8.7281 14.4977 7.96992 15.0768 7.70003 15.8784H3.40625C3.0503 15.8784 2.76172 16.167 2.76172 16.5229C2.76172 16.8789 3.0503 17.1675 3.40625 17.1675H7.70003C7.96992 17.969 8.7281 18.5482 9.61953 18.5482C10.511 18.5482 11.2691 17.969 11.539 17.1675H18.5943C18.9502 17.1675 19.2388 16.8789 19.2388 16.5229C19.2388 16.167 18.9502 15.8784 18.5942 15.8784ZM9.61953 17.2592C9.21361 17.2592 8.88335 16.9289 8.88335 16.523C8.88335 16.117 9.21361 15.7868 9.61953 15.7868C10.0255 15.7868 10.3557 16.117 10.3557 16.5229C10.3557 16.9289 10.0255 17.2592 9.61953 17.2592Z",
                      fill: "#253342",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between services-filter-container",
        },
        [
          _c(
            "div",
            { staticClass: "bb-view-filter" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-radio-group", {
                    ref: "switchView",
                    attrs: {
                      id: "bb_table_view_filter_toggle",
                      options: _vm.tableViews,
                      buttons: "",
                      name: "radios-btn-default",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.switchView()
                      },
                    },
                    model: {
                      value: _vm.selectedView,
                      callback: function ($$v) {
                        _vm.selectedView = $$v
                      },
                      expression: "selectedView",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.selectedView === "services"
            ? _c(
                "button",
                {
                  staticClass: "bb-btn btn-success btn-lg new-staff-btn",
                  on: {
                    click: function ($event) {
                      return _vm.createService()
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("services.createServiceBtn")) + " "
                  ),
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "bb-btn btn-success btn-lg new-staff-btn",
                  on: {
                    click: function ($event) {
                      return _vm.openCreateCategoryModal()
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("services.createCategoryBtn")) + " "
                  ),
                ]
              ),
        ]
      ),
      _c("v-data-table", {
        ref: "servicesTable",
        staticClass: "bb-table services-table",
        attrs: {
          headers: _vm.tableHeaders,
          items: _vm.servicesItems,
          "hide-default-footer": "",
          "hide-default-header": "",
          "group-by": "serviceCategoryName",
          "show-group-by": "",
          "disable-pagination": true,
        },
        scopedSlots: _vm._u(
          [
            {
              key: `group.header`,
              fn: function ({ headers, group }) {
                return [
                  _c(
                    "td",
                    {
                      staticClass: "bb-table-group-header",
                      attrs: { colspan: headers.length },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          !_vm.isInputVisible(group)
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isInputVisible(group),
                                          expression: "!isInputVisible(group)",
                                        },
                                      ],
                                      staticClass: "bb-table-group-header-text",
                                    },
                                    [_vm._v(_vm._s(group))]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isInputVisible(group),
                                          expression: "!isInputVisible(group)",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.showInput(group)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "feather feather-edit-2",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "#516F90",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isInputVisible(group),
                                expression: "isInputVisible(group)",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.input.value,
                                expression: "input.value",
                              },
                            ],
                            staticClass: "bb-input edit-category-name-input",
                            attrs: {
                              type: "text",
                              id:
                                group.toLowerCase().replace(/ /g, "_") +
                                "_input",
                            },
                            domProps: { value: _vm.input.value },
                            on: {
                              blur: function ($event) {
                                return _vm.updateServiceCategoryName()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.input,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "table-header-add-service-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.createService({
                                        category: group,
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "services.table.createServiceBtn"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("BBDropdown", {
                                staticClass: "service-category-dropdown",
                                attrs: { positionClass: "right" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "toggle",
                                      fn: function () {
                                        return [
                                          _c("i", {
                                            staticClass: "ki ki-more-ver",
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "items",
                                      fn: function ({ closeDropdown }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "action-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.createService({
                                                    category: group,
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "services.table.dropdown.createServiceBtn"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "action-item",
                                              on: {
                                                click: function ($event) {
                                                  _vm.showInput(group)
                                                  closeDropdown()
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "services.table.dropdown.editCategoryNameBtn"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "action-item danger",
                                              on: {
                                                click: function ($event) {
                                                  _vm.deleteServiceCategory(
                                                    group
                                                  )
                                                  closeDropdown()
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "services.table.dropdown.deleteCategoryBtn"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "text-right mobile-edit-service-category-btn",
                              staticStyle: {
                                position: "absolute",
                                right: "25px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showMobileActions(group)
                                },
                              },
                            },
                            [_c("i", { staticClass: "ki ki-more-ver" })]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "tr",
                    {
                      staticClass: "service-item-row",
                      class: {
                        "empty-category-service-row":
                          item.isEmptyCategoryPlaceholder,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleTableRowClick(item)
                        },
                      },
                    },
                    [
                      _c("td", { staticClass: "text-left name-cell" }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                        _c("span", { staticClass: "mobile-duration-text" }, [
                          _vm._v(_vm._s(item.duration)),
                        ]),
                        _c("span", { staticClass: "mobile-price-text" }, [
                          _vm._v(_vm._s(item.price)),
                        ]),
                      ]),
                      _c("td", { staticClass: "text-left description-cell" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.description
                                ? item.description.substring(0, 85) + ".."
                                : _vm.$t("services.table.noDescriptionLabel")
                            ) +
                            " "
                        ),
                      ]),
                      _c("td", { staticClass: "text-left duration-cell" }, [
                        _vm._v(_vm._s(item.duration)),
                      ]),
                      _c("td", { staticClass: "text-left group-label-cell" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.isGroupService,
                                expression: "item.isGroupService",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  `${_vm.$t(
                                    "services.table.groupServiceLabel"
                                  )} (${item.sameTimePeople})`
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("td", { staticClass: "text-right edit-cell" }, [
                        _c("div", { staticClass: "table-action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "table-action-button",
                              on: {
                                click: function ($event) {
                                  _vm.editService(_vm.getService(item))
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "feather feather-edit",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "table-action-button",
                              on: {
                                click: function ($event) {
                                  _vm.deleteService(_vm.getService(item))
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "feather feather-trash-2",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("polyline", {
                                    attrs: { points: "3 6 5 6 21 6" },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                                    },
                                  }),
                                  _c("line", {
                                    attrs: {
                                      x1: "10",
                                      y1: "11",
                                      x2: "10",
                                      y2: "17",
                                    },
                                  }),
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "11",
                                      x2: "14",
                                      y2: "17",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "button",
        {
          staticClass: "mobile-new-service-btn",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleMobileCreateClick()
            },
          },
        },
        [_c("i", { staticClass: "la la-plus" })]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileActionsVisible,
              expression: "mobileActionsVisible",
            },
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleMobileActionsOutsideClick,
              expression: "handleMobileActionsOutsideClick",
            },
          ],
          staticClass: "mobile-service-actions-container",
          attrs: { id: "mobile_actions_container" },
        },
        [
          _c("div", { staticClass: "mobile-service-actions" }, [
            _c(
              "button",
              {
                staticClass: "mobile-service-action-btn",
                on: {
                  click: function ($event) {
                    _vm.createService({ category: _vm.selectedCategoryName })
                    _vm.hideMobileActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("services.mobileButtons.createServiceBtn")) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "mobile-service-action-btn",
                on: {
                  click: function ($event) {
                    _vm.showInput(_vm.selectedCategoryName)
                    _vm.hideMobileActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("services.mobileButtons.editCategoryNameBtn")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "mobile-service-action-btn danger",
                on: {
                  click: function ($event) {
                    _vm.deleteServiceCategory(_vm.selectedCategoryName)
                    _vm.hideMobileActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("services.mobileButtons.deleteCategoryBtn")) +
                    " "
                ),
              ]
            ),
          ]),
          _c(
            "button",
            {
              staticClass: "mobile-service-action-btn",
              on: { click: _vm.hideMobileActions },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("services.mobileButtons.closeBtn")) + " "
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileServiceActionsVisible,
              expression: "mobileServiceActionsVisible",
            },
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleMobileServiceActionsOutsideClick,
              expression: "handleMobileServiceActionsOutsideClick",
            },
          ],
          staticClass: "mobile-service-actions-container",
          attrs: { id: "mobile_service_actions_container" },
        },
        [
          _c("div", { staticClass: "mobile-service-actions" }, [
            _c(
              "button",
              {
                staticClass: "mobile-service-action-btn",
                on: {
                  click: function ($event) {
                    _vm.editService(_vm.selectedService)
                    _vm.hideMobileServiceActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("services.mobileServiceButtons.editServiceBtn")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "mobile-service-action-btn danger",
                on: {
                  click: function ($event) {
                    _vm.deleteService(_vm.selectedService)
                    _vm.hideMobileServiceActions()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("services.mobileServiceButtons.deleteServiceBtn")
                    ) +
                    " "
                ),
              ]
            ),
          ]),
          _c(
            "button",
            {
              staticClass: "mobile-service-action-btn",
              on: { click: _vm.hideMobileServiceActions },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("services.mobileServiceButtons.closeBtn")) +
                  " "
              ),
            ]
          ),
        ]
      ),
      _c("MobileServicesFilter", {
        attrs: { currentFilter: _vm.selectedView },
        on: {
          "filter-updated": function ($event) {
            return _vm.filterUpdated($event)
          },
        },
      }),
      _c("ServiceFormModal", { ref: "serviceFormModal" }),
      _c(
        "b-modal",
        {
          ref: "createCategoryModal",
          attrs: { id: "create_service_category_modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("services.createCategoryModal.title"))
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      attrs: { id: "create_service_category_modal_close_btn" },
                      on: { click: close },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-x",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "17",
                            height: "17",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                          }),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-secondary",
                      on: {
                        click: function ($event) {
                          return _vm.closeCreateCategoryModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("services.createCategoryModal.cancelBtn")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-success",
                      on: {
                        click: function ($event) {
                          return _vm.createServiceCategory()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("services.createCategoryModal.saveBtn")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "bb-form-group" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("services.createCategoryModal.nameInput.label"))
              ),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newCategoryName,
                  expression: "newCategoryName",
                },
              ],
              staticClass: "bb-input",
              attrs: {
                type: "text",
                placeholder: _vm.$t(
                  "services.createCategoryModal.nameInput.placeholder"
                ),
              },
              domProps: { value: _vm.newCategoryName },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.createServiceCategory()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.newCategoryName = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "bb-form-group" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("services.createCategoryModal.imageInput.label"))
              ),
            ]),
            _c("div", { staticClass: "category-image-upload" }, [
              _vm.newCategoryImagePreview
                ? _c("img", {
                    staticClass: "category-image-preview",
                    attrs: { src: _vm.newCategoryImagePreview },
                  })
                : _vm._e(),
              _c("input", {
                ref: "categoryImageInput",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: "image/*" },
                on: { change: _vm.handleCategoryImageChange },
              }),
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-outline",
                  on: {
                    click: function ($event) {
                      return _vm.$refs.categoryImageInput.click()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "services.createCategoryModal.imageInput.uploadBtn"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
              _vm.newCategoryImagePreview
                ? _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-outline danger",
                      on: {
                        click: function ($event) {
                          return _vm.removeCategoryImage()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "services.createCategoryModal.imageInput.removeBtn"
                            )
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "editCategoryImageModal",
          attrs: { id: "edit_category_image_modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("services.editCategoryImageModal.title"))
                    ),
                  ]),
                  _c("button", { on: { click: close } }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "17",
                          height: "17",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _c("div", { staticClass: "bb-form-group" }, [
            _c("div", { staticClass: "category-image-upload" }, [
              _vm.editCategoryImagePreview
                ? _c("img", {
                    staticClass: "category-image-preview",
                    attrs: { src: _vm.editCategoryImagePreview },
                  })
                : _vm._e(),
              _c("input", {
                ref: "editCategoryImageInput",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: "image/*" },
                on: { change: _vm.handleEditCategoryImageChange },
              }),
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-outline",
                  on: {
                    click: function ($event) {
                      return _vm.$refs.editCategoryImageInput.click()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("services.editCategoryImageModal.uploadBtn")
                      ) +
                      " "
                  ),
                ]
              ),
              _vm.editCategoryImagePreview
                ? _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-outline danger",
                      on: {
                        click: function ($event) {
                          _vm.editCategoryImage
                            ? _vm.removeEditCategoryImage()
                            : _vm.deleteCategoryImage()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("services.editCategoryImageModal.removeBtn")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }